import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Отправка уведомления диспетчерам",
    loading: _ctx.loading,
    onConfirm: _ctx.emitSubmit,
    onCancel: _ctx.emitCancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_checkbox, {
          disabled: _ctx.loading,
          value: _ctx.state.is_confirmed,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.is_confirmed) = $event)),
          label: "Подтверждено"
        }, null, 8, ["disabled", "value"]),
        _createVNode(_component_the_button, {
          disabled: _ctx.loading,
          class: "primary small",
          onClick: _ctx.emitSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Подтвердить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_the_textarea, {
        autoheight: "",
        rows: 4,
        placeholder: "Комментарий диспетчеру",
        value: _ctx.state.comment,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.comment) = $event)),
        "is-invalid": _ctx.state_form$.comment.$error,
        "validation-errors": _ctx.state_form$.comment.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onConfirm", "onCancel"]))
}